import { combineReducers } from 'redux';
import vocabTQVMReducer from './tqvm/vocabTQVMReducer';
import vocabFITBReducer from './fitb/vocabFITBReducer';
import vocabBDReducer from './bd/vocabBDReducer';

const vocabReducers = {
    tqvm: vocabTQVMReducer,
    fitb: vocabFITBReducer,
    bd: vocabBDReducer,
};

const vocabReducer = combineReducers(vocabReducers);

export default vocabReducer;
